const StatusColorTwo = (a) => {
  if (a > 0) {
    return "veryLowRisk";
  } else {
    return "red7";
  }
};

export default StatusColorTwo;
